import { Directive, ElementRef, Input } from '@angular/core';
import { User } from '../models/user';

@Directive({
  selector: '[appAffiliation]'
})
export class AffiliationDirective {

  @Input() affiliations!: Array<string>;
  constructor(private elementRef: ElementRef) {
  }

  ngOnInit() {
    const user = new User(JSON.parse(localStorage.getItem('user')!));

    if (this.affiliations.filter((el) => user.affiliation.toLocaleLowerCase() === el).length == 0) {
      this.elementRef.nativeElement.style.display = 'none';
    }
  }

}
